import { MenuProps, Popover } from 'antd';
import { useNavigate, useParams } from 'react-router';
import { useAppDispatch, useAppSelector } from 'store/hook';
import { setRooms, setSelectedDataRoom, setUserAndRoomStatus } from 'store/slices/userDataSlice';
import { fetchRoom } from 'store/reducers/roomsCreator';
import { fetchUserPermissions } from 'store/reducers/userDataCreator';
import {
  narrowSidebarWidth,
  setIsDeletingDocuments,
  setIsEditRoomModalOpen,
  setIsLoadingProcess,
  setIsTariffInfoModalOpen,
  setIsUploadingDocuments,
  setSelectedKeys,
  setTariffInfoModalRoom,
} from 'store/slices/windowStateSlice';
import { useTranslation } from 'react-i18next';
import classes from './RoomsTab.module.scss';
import React from 'react';
import { setFoldersForPermissions } from 'store/slices/dataPermissionsSlice';
import { ConfirmModal, DeleteRoomModal, EditRoomModal, NewRoomModal } from 'components/Modals';
import RoomsTabControl from './RoomsTabControl';
import { IDataRoom } from 'interfaces';
import EmptyRoom from './EmptyRoom';
import RowLoader from 'components/Sceletons/RowLoader';
import Mark from 'mark.js';
import RoomCard from './RoomCard';
import systemPages from 'helpers/pagesAndLocation';
import api from 'api';
import { setIsOpenConfrimInvite, setNotifications, setNotificationsStatus, setRoomToConfirm } from 'store/slices/dataRoomSlice';
import { Tariffs } from 'components/TariffsComponent/tariffsData';
import { ERoomFilters } from 'interfaces/IDataRoom';
import Assets from 'assets/icons';
import dayjs from 'dayjs';
import billing, { paymentUrl } from 'api/billing';
import { checkIsTariffEnded, checkIsAwaitingPayment } from 'helpers/tariffPayment';
import UploadingComponent from 'components/UploadingComponent/UploadingComponent';
import { setAllTagsDocuments } from 'store/slices/chatsSlice';
import { setDefaultView } from 'store/reducers/documentsCreator';
import { VariableSizeList } from 'react-window';
const isBillingActive = window.REACT_APP_IS_BILLING_ACTIVE !== 'REPLACE_REACT_APP_IS_BILLING_ACTIVE' ? window.REACT_APP_IS_BILLING_ACTIVE : process.env.REACT_APP_IS_BILLING_ACTIVE;
const paymentType = window.REACT_APP_PAYMENT_TYPE !== 'REPLACE_REACT_APP_PAYMENT_TYPE' ? window.REACT_APP_PAYMENT_TYPE : process.env.REACT_APP_PAYMENT_TYPE || 'jusan';

type RoomsTabProps = {
  clearRedux: () => void;
  widthSB: number;
};

const RoomsTab = ({clearRedux, widthSB}: RoomsTabProps) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const [isNewRoomModal, setIsNewRoomModal] = React.useState(false);
  const [isConfirmLoading, setIsConfirmLoading] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('');
  const [filterValue, setFilterValue] = React.useState<ERoomFilters>(ERoomFilters.All);
  const [displayingRooms, setDisplayingRooms] = React.useState<IDataRoom[] | null>(null);
  const [height, setHeight] = React.useState(0);

  const params = useParams();
  const wrapRooms = React.useRef<HTMLDivElement | null>(null);

  const { userData, selectedRoom, isLoadingUserData, available_rooms, isLoadingRooms } = useAppSelector((store) => store.userData);
  const { dataRoom, isLoadingRoom, notifications, roomToConfirm, isOpenConfrimInvite } = useAppSelector((store) => store.dataRoom);
  const { selectedKeys, isEditRoomModalOpen, isLoadingProcess, messageApi } = useAppSelector((store) => store.windowState);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  
  const widthOfSideBar = Number(localStorage.getItem('sideBarWidth')) || widthSB;
  const isNormalSideBar = widthOfSideBar ? (widthOfSideBar > narrowSidebarWidth) : true;

  React.useEffect(() => {
    switch(filterValue) {
      case ERoomFilters.Administrator:
        return setDisplayingRooms(available_rooms?.filter((room) => room.owner_id !== userData?.id && room.is_admin));
      case ERoomFilters.Owner:
        return setDisplayingRooms(available_rooms?.filter((room) => room.owner_id === userData?.id));
      case ERoomFilters.Member:
        return setDisplayingRooms(available_rooms?.filter((room) => room.owner_id !== userData?.id && !room.is_admin));
      default:
        return setDisplayingRooms(available_rooms)
    }
  },[filterValue, available_rooms]);

  
  const updateSize = () => {    
    if (wrapRooms.current?.offsetHeight) setHeight(Number(wrapRooms.current?.offsetHeight) - 10);
  };
  
  React.useEffect(() => {
    if (wrapRooms.current) {
      window.addEventListener('resize', updateSize);
      updateSize();
    }
    return () => window.removeEventListener('resize', updateSize);
  }, [wrapRooms.current]);

  React.useEffect(() => {
    if (selectedKeys[0] === 'documents') {
      setTimeout(() => {
        updateSize()
      }, 1);
    }
  }, [selectedKeys]);
  
  const searchedRooms = React.useMemo(
    () => displayingRooms?.filter((room) => room.name?.toLowerCase()?.includes(searchValue?.toLocaleLowerCase())),
    [searchValue, displayingRooms]
  );

  const onEditRoomCancel = () => dispatch(setIsEditRoomModalOpen(false));
  const onDeleteRoomCancel = () => setIsDeleteModalOpen(false);

  const onOpenClick = async (_: any, room: IDataRoom, isLoadingRoom: boolean, option: string = 'documents') => {
    if (room?.invite_id){
      dispatch(setIsOpenConfrimInvite(true));
      dispatch(setRoomToConfirm(room));
      return;
    }
    dispatch(setDefaultView());
    let rightOption = room?.access_terms_status == 'waiting_for_approve' ? 'nda' : option;    
    
    // очищаем статусы-индикаторы загрузки - от залипания бесконечной загрузки при переходе в новую комнату
    dispatch(setIsLoadingProcess(false));
    dispatch(setIsUploadingDocuments(false));
    dispatch(setIsDeletingDocuments(false));
    
    if ((dataRoom?.id !== room.id || systemPages.includes(selectedKeys[0])) && !isLoadingRoom) {
      clearRedux();
      dispatch(setAllTagsDocuments([]));
      dispatch(setUserAndRoomStatus(''))
      dispatch(setFoldersForPermissions([]));
      dispatch(setSelectedKeys([`${rightOption}`]));
      dispatch(setSelectedDataRoom(room));
      navigate(`/room/${room.custom_url || room.id}/${rightOption}`);

      // RETURNED BILLING        
      if (isBillingActive === 'true') {
        if (checkIsTariffEnded(room)) {
          navigate(`/room/${room?.id}/endedTariff`);
          await dispatch(fetchRoom({ id: room.id }));
          return;
        } else if (checkIsAwaitingPayment(room)) {
          navigate(`/room/${room?.id}/awaitingPayment`);
          await dispatch(fetchRoom({ id: room.id }));
          return;
        }
      }
      await dispatch(fetchRoom({ id: room.id }));
      await dispatch(fetchUserPermissions({ idRoom: room.id }));
      dispatch(setUserAndRoomStatus('fulfilledDataRoom')); // были проблемы с обновлением ло статуса fulfilledDataRoom для этого в начале стоит setUserAndRoomStatus('')
    } else {
      dataRoom?.id !== room.id && params.room !== room.id && !isLoadingRoom && navigate(`/room/${room.custom_url || room.id}/${rightOption}`);
    }
  };

  const onEditClick = (e: any, room: IDataRoom) => {
    e.domEvent.stopPropagation();
    dispatch(setIsEditRoomModalOpen(true));    
    dispatch(setSelectedDataRoom(room));
  };

  const reRegisterIOSPayment = async (room: IDataRoom) => {
    dispatch(setIsLoadingProcess(true));

    const tariffJSON = {
      room_id: room.id,
      tariff_id: room?.tariff?.id,
      cost: room?.tariff?.cost,
      constraints: room?.tariff?.constraints,
      payment_type: paymentType,
    };
    
    try {
      const { data: paymentData } = await billing.registerBill(tariffJSON);
      return paymentData
    } catch (e) {
      messageApi?.error(t('Header.error.register'));
    } finally {
      dispatch(setIsLoadingProcess(false));
    };
  };

  const onPay = async (e: any, room: IDataRoom) => {
    e.domEvent.stopPropagation();
    if (room.tariff?.status?.toLowerCase() === 'awaiting_payment') {
      let paramsJSON: any;
      if (room?.tariff?.last_payment_intent?.payment_service === 'ios_iap') {
        paramsJSON = await reRegisterIOSPayment(room);
      } else {
        paramsJSON = room?.tariff?.last_payment_intent?.link && JSON.parse(room?.tariff?.last_payment_intent?.link);
      };
      if (['robokassa', 'ios_iap'].includes(room?.tariff?.last_payment_intent?.payment_service)) {
        window.location.href = paramsJSON?.payment_link;
      } else {
        let qveryParams: string[] = [];
        for (const key in paramsJSON) {
          const value = paramsJSON[key] ? paramsJSON[key] : '';
          qveryParams.push(`${key}=${value}`);
        };
        const correctParams = qveryParams.join('&').replace('&redirect=true', '%26redirect=true');
        window.location.href = `${paymentUrl}?${correctParams}`;
      }
      
    } else {      
      dispatch(setIsLoadingProcess(true));
      
      const constraints = room?.tariff?.constraints;
      const tariffConstraints = constraints ? {
        storage: constraints.storage,
        members: constraints.members,
        ...(constraints.rooms && { rooms: constraints.rooms }),
      } : null;
      
      const extendData: any = {
        tariff_data: {
          tariff_name: room?.tariff?.tariff_name,
          tariff_cost: room?.tariff?.cost,
          tariff_duration: room?.tariff?.duration,
          tariff_duration_unit: room?.tariff?.duration_unit,
          tariff_constraints: tariffConstraints,
          room_id: room?.id,
        },
        payment_type: paymentType,
      };
      try {
        const { data: paymentData } = await billing.extendBillV2(extendData);
        if (paymentType === 'jusan') {
          let qveryParams: string[] = [];
          for(const key in paymentData){
            const value = paymentData[key] ? paymentData[key] : '';
            qveryParams.push(`${key}=${value}`);
          };
          const correctParams = qveryParams.join('&').replace('&redirect=true', '%26redirect=true');
          window.location.href = `${paymentUrl}?${correctParams}`;
        } else {
          window.location.href = paymentData.payment_link;
        };
      } catch (e) {
        messageApi?.error(t('Header.error.extend'));
      } finally {
        dispatch(setIsLoadingProcess(false));
      };
    };
  };

  const onDeleteClick = (e: any, room: IDataRoom) => {
    e.domEvent.stopPropagation();
    dispatch(setSelectedDataRoom(room));
    setIsDeleteModalOpen(true);
  };

  const onTariffInfoClick = (e: any, room: IDataRoom) => {
    e.domEvent.stopPropagation();
    dispatch(setTariffInfoModalRoom(room));
    dispatch(setIsTariffInfoModalOpen(true));
  };

  const markText = (text: string, markerRef: React.RefObject<HTMLDivElement>, timeout?: number ) => {    
    const markInstance = new Mark(markerRef.current as HTMLElement);
    
    setTimeout(() => {
      markInstance.unmark({
        className: classes.mark,
        done: () => {
          markInstance.mark(text, {
            className: classes.mark,
          });
        }
      });
    }, timeout || 100);
  }

  const controlItems = (room: IDataRoom, needLoad: boolean, canEditRoom: boolean): MenuProps['items'] => {
    const current = dayjs().valueOf();
    const endedNewPeriod = room?.tariff?.tariff_ends_at && dayjs.utc(room.tariff?.tariff_ends_at).valueOf();

    const isOwner = userData?.id === room.owner_id;
    const needToAcceptTerms = room?.user_status === 1 || room?.access_terms_status === 'waiting_for_approve';
    const isPaidTariff = isBillingActive === 'true' && ((Number(endedNewPeriod) - current) > 0)
      && room?.tariff?.tariff_name !== Tariffs.Trial;
    const isTrialTariff = isBillingActive === 'true' && ((Number(endedNewPeriod) - current) > 0) && room?.tariff?.tariff_name === Tariffs.Trial;
    
    let items: MenuProps["items"] = [
      {
        key: 'delete',
        className: classes.controlMenuItem,
        label: (isPaidTariff || isTrialTariff)
          ? (<Popover title={isPaidTariff ? t('Rooms.popovers.paidRoom') : t('Rooms.popovers.trialRoom')}>
            <span className={classes.spanItem}>
              <Assets.TrashIcon /> {t('Users.HelperMenu.delete')}
            </span>
          </Popover>)
          : (isOwner
            ? (<span className={classes.spanItem}>
              <Assets.TrashIcon /> {t('Users.HelperMenu.delete')}
            </span>)
            : (<Popover title={t('Rooms.popovers.delete')}>
              <span className={classes.spanItem}>
                <Assets.TrashIcon /> {t('Users.HelperMenu.delete')}
              </span>
            </Popover>)
          ),
        onClick: (e) => onDeleteClick(e, room),
        disabled: !isOwner || isPaidTariff || needToAcceptTerms || isTrialTariff,
      },
    ];

    if ((canEditRoom && !needToAcceptTerms) || needLoad) {
      items.push({
        type: 'divider',
        className: classes.divider,
      });
      items.push({
        key: 'edit',
        className: classes.controlMenuItem,
        label: needLoad
          ? <RowLoader height={22} width={90} padding={'0 0 0 6px'} marginBottom={-6}/>
          : <span className={classes.spanItem}>
              <Assets.EditIcon /> {t('Users.HelperMenu.edit')}
            </span>,
        onClick: (e) => onEditClick(e, room),
      })
    }
    
    // if (isBillingActive === 'true' && room.tariff?.last_payment_intent?.link) {
    //   if ((room.lives_to !== null && room.tariff?.tariff_name !== Tariffs.Trial) || (room?.tariff?.tariff_name && room?.tariff?.tariff_ends_at === null)) {
    //     items.push({
    //       type: 'divider',
    //       className: classes.divider,
    //     });
    //     items.push({
    //       key: 'pay',
    //       className: classes.controlMenuItem,
    //       label: (
    //         <span className={classes.spanItem}>
    //           <Assets.VerifyIcon /> {t('Users.HelperMenu.pay')}
    //         </span>
    //         ),
    //         onClick: (e) => onPay(e, room),
    //       })
    //     };
    //   }

      if (isBillingActive === 'true' && room?.tariff?.tariff_name) {
        items.push({
          type: 'divider',
          className: classes.divider,
        });
        items.push({
          key: 'tariffInfo',
          className: classes.controlMenuItem,
          label: (
            <span className={classes.spanItem}>
              <Assets.CreditCardIcon /> {t('Users.HelperMenu.tariffInfo')}
            </span>
          ),
          onClick: (e) => onTariffInfoClick(e, room),
        });
      }

    return items;
  }

  const onConfirmClose = () => dispatch(setIsOpenConfrimInvite(false));
  const onRejectInvite = async () => {
    setIsConfirmLoading(true);
    try {
      await api.declineInvite(roomToConfirm?.invite_id!);
      messageApi?.success(t('Header.Notification.invites.success.declined'));
      dispatch(setNotificationsStatus('pending'));
      dispatch(
        setNotifications(
          notifications.map((not, idx) =>
            not.details.invite_id === roomToConfirm?.invite_id
              ? { ...not, details: { ...not.details, invite_status: 2 as any } }
              : not
          )
        )
      );
      
      dispatch(setRooms(available_rooms.filter(({ id }) => id !== roomToConfirm?.id)!));
      setTimeout(() => dispatch(setNotificationsStatus('fulfilled')), 10);
    } catch (Err) {
      messageApi?.error(t('Header.Notification.invites.error.declined'));
    } finally {
      onConfirmClose();
      setIsConfirmLoading(false);
    }
  };

  const onAcceptInvite = async () => {
    try {
      setIsConfirmLoading(true);
      const respRoom = await api.acceptInvite(roomToConfirm?.invite_id!);
      messageApi?.success(t('Header.Notification.invites.success.accepted'));
      dispatch(setNotificationsStatus('pending'));
      const targetRoom = await api.getRoom(respRoom.data.id);

      dispatch(
        setNotifications(
          notifications.map((not, idx) =>
            not.details.invite_id === roomToConfirm?.invite_id
              ? { ...not, details: { ...not.details, invite_status: 1 as any } }
              : not
          )
        )
      );
          
      dispatch(setRooms(available_rooms.map((room) =>
        room.id === roomToConfirm?.id
        ? targetRoom.data
        : room
      )));

      onOpenClick(null, targetRoom.data, isLoadingRoom);

      setTimeout(() => dispatch(setNotificationsStatus('fulfilled')), 10);
    } catch (Err) {
      messageApi?.error(t('Header.Notification.invites.error.accepted'));
    } finally {
      onConfirmClose();
      setIsConfirmLoading(false);
    }
  };
  
  const getSize = React.useCallback(
    (idx: number) => {
      return 76
    },
    [searchedRooms]
  );
  
  const VariableSizeListAny = VariableSizeList as any;
  
  return (
    <div className={classes.rooms}>
      {isNormalSideBar && <RoomsTabControl
        setIsVisibleModal={setIsNewRoomModal}
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        isLoadingUserData={isLoadingUserData || isLoadingRooms}
        setFilterValue={setFilterValue}
        filterValue={filterValue}
      />}
      {
        isLoadingRooms
          ? <div style={{marginRight: 10, paddingTop: 10}}>
            <RowLoader width={600} padding={'0 0 0 6px'} height={72} borderradius={5}/>
            <RowLoader width={600} padding={'0 0 0 6px'} height={72} borderradius={5}/>
          </div>
          : <div ref={wrapRooms} className={classes.roomCardsWrap} data-testid='sidebar-rooms-tab' id='sidebar-rooms-tab'>
            {(searchedRooms && !searchedRooms[0] && !isLoadingUserData) || isLoadingRooms
              ? <EmptyRoom />
              : <VariableSizeListAny
                height={height}
                // outerRef={outerRef}
                // innerRef={innerRef}
                itemCount={searchedRooms?.length || 0}
                itemSize={getSize}
                width={'100%'}
                style={{overflowY: 'scroll'}}
                itemData={searchedRooms}
              >
                {({ index, style }: any) => {
                  return (
                    <div key={searchedRooms![index].id + index}>
                      <RoomCard
                        room={searchedRooms![index]}
                        onOpenClick={onOpenClick}
                        controlItems={controlItems}
                        style={style}
                        searchValue={searchValue}
                        markText={markText}
                        isNormalSideBar={isNormalSideBar}
                      />
                    </div>
                  );
                }}
              </VariableSizeListAny>
            }
          </div>
      }

      {isDeleteModalOpen && (
        <React.Suspense fallback={<div />}>
          <DeleteRoomModal t={t} room={selectedRoom!} onCancel={onDeleteRoomCancel} isOpen={isDeleteModalOpen} />
        </React.Suspense>
      )}

      {isEditRoomModalOpen && (
        <React.Suspense fallback={<div />}>
          <EditRoomModal t={t} room={selectedRoom!} onCancel={onEditRoomCancel}  isOpen={isEditRoomModalOpen} />
        </React.Suspense>
      )}

      {isNewRoomModal && (
        <React.Suspense fallback={<div />}>
          <NewRoomModal open={isNewRoomModal} onCancel={() => setIsNewRoomModal(false)}/>
        </React.Suspense>
      )}

      {isOpenConfrimInvite && (
        <React.Suspense fallback={<div />}>
          <ConfirmModal
            okText={t('Confirm.accept')}
            cancelText={t('Confirm.reject')}
            bodyContent={roomToConfirm?.is_expired
              ? `${t('Rooms.modals.confirmInvite.expiredBodyStart')} '${roomToConfirm?.name}' ${t('Rooms.modals.confirmInvite.expiredBodyEnd')}`
              : `${t('Rooms.modals.confirmInvite.body')} - '${roomToConfirm?.name}'?`
            }
            onCancel={!roomToConfirm?.is_expired ? onRejectInvite : undefined}
            onClose={onConfirmClose}
            onOk={!roomToConfirm?.is_expired ? onAcceptInvite : undefined}
            loading={isConfirmLoading}
            open={isOpenConfrimInvite}
            title={roomToConfirm?.is_expired 
              ? t('Rooms.modals.confirmInvite.expiredTitle')
              : t('Rooms.modals.confirmInvite.title')
            }
          />
        </React.Suspense>
      )}

      { isLoadingProcess &&
        <UploadingComponent />
      }
    </div>
  );
}

export default RoomsTab;
